import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';

var root = $.from_html(`<div class="empty-state svelte-31gaf7ymqa6og"><span class="empty-icon svelte-31gaf7ymqa6og"> </span> <h3 class="svelte-31gaf7ymqa6og"> </h3> <p class="svelte-31gaf7ymqa6og"> </p></div>`);

function EmptyState($$anchor, $$props) {
	let icon = $.prop($$props, 'icon', 3, '🌿');
	var div = root();
	var span = $.child(div);
	var text = $.child(span, true);

	$.reset(span);

	var h3 = $.sibling(span, 2);
	var text_1 = $.child(h3, true);

	$.reset(h3);

	var p = $.sibling(h3, 2);
	var text_2 = $.child(p, true);

	$.reset(p);
	$.reset(div);

	$.template_effect(() => {
		$.set_text(text, icon());
		$.set_text(text_1, $$props.title);
		$.set_text(text_2, $$props.description);
	});

	$.append($$anchor, div);
}

if (import.meta.hot) {
	EmptyState = $.hmr(EmptyState);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-31gaf7ymqa6og');
		EmptyState[$.HMR].update(module.default);
	});
}

export default EmptyState;
import "bun-svelte:EmptyState.svelte-3onfj9yuffve6-style.css";